import { createContext } from 'react';

const FilterContext = createContext(null);

export default FilterContext;



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/FilterContext.js